module.exports = __webpack_public_path__ + "img/basketPlayScore.e0b83cc5.jpg";